export default __webpack_public_path__ + "static/About-11faa228a8653a4a9e0e1880e28d9465.png";